/*
* @描述: 订单列表
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/12 16:59
*/
<template>
    <PullContainer ref="pullContainerRef"
                   :pullDownLabel="true"
                   :pullDownLoading="true"
                   @pullDownLoadingSuccess="pullDownLoadingSuccess">
        <template #container>
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="true" :isTitleNormal="true" title="返回">
                    </ReturnNavBar>
                    <span class="handle_icon_wrap" @click="handleClickAddOrder">
                        <i class="iconfont icon-a-tianjiamiaobian"></i>
                    </span>
                </div>
                <div class="top_search">
                    <van-search v-model="searchForm.keyword"
                                placeholder="请输入查询内容"
                                @clear="onSearch"
                                @search="onSearch">
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <ul v-infinite-scroll="scrollLoadList" class="order_list">
                        <li v-for="(row, index) in orderTableList" :key="index" class="order_item">
                            <div class="order_item_header">
                                <div class="flex_wrap">
                                    <div v-if="row.is_release===0" class="order_is_release">订单未发布</div>
                                    <div v-else class="order_num_wrap"
                                         @click="handleClickOrderDetail(row)"
                                         v-text="row.order_num">
                                    </div>
                                    <div v-if="row.is_release!==0&&row.is_bad_debt!==1"
                                         :class="'order_status_name_'+row.order_status"
                                         class="order_status_name"
                                         v-text="row.order_status_name"></div>
                                    <van-tag v-if="row.is_bad_debt===1" color="rgba(228, 65, 68, 0.1)"
                                             text-color="#E44144">坏账
                                    </van-tag>
                                </div>
                                <span class="handle_icon_wrap" @click="handleClickOrderHandle(row)">
                    <i class="iconfont el-icon-more"></i>
                </span>
                            </div>
                            <div class="order_item_content">
                                <div class="flex_wrap">
                                    <span class="field_label">客户：</span>
                                    <span class="field_value"
                                          v-text="row.customer_id&&row.customer_id.text?row.customer_id.text:'--'"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">销售：</span>
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard :userId="row.uid">
                                            <template slot="container">
                                                <img :src="row.salesperson_avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.salesperson_name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">订单总金额：</span>
                                    <span class="field_value"
                                          v-text="row.total_price&&row.total_price.text?row.total_price.currency+row.total_price.text:'--'"></span>
                                </div>
                            </div>
                        </li>
                        <li v-if="orderTableList.length >= pagination.total" class="ta_c">--已经到底了--</li>
                    </ul>
                </div>
                <FooterTabbar :tabBarActive="tabBarActive" :tabBarList="tabBarList"></FooterTabbar>
                <ListAdvancedFiltering
                        v-if="searchPopupShow"
                        ref="listAdvancedFiltering"
                        :field_form="'orders'"
                        :system_fields="systemFilterFields"
                        @sendFilterData="getFilterData"/>
                <van-overlay v-if="handleRadioPicker"
                             :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                             :show="handleRadioPicker"
                             z-index="1000"
                             @click="handleRadioPicker = false">
                    <div class="custom_radio_option_wrap">
                        <ul class="radio_option_list">
                            <li v-if="activeOrder.order_status===0" class="radio_option_item"
                                @click="handleClickRevokeOrder">撤销
                            </li>
                            <li v-if="activeOrder.order_status===1" class="radio_option_item"
                                @click="handleClickAfterSales">订单售后
                            </li>
                            <li v-if="activeOrder.order_status===4" class="radio_option_item"
                                @click="handleClickEditOrder">编辑
                            </li>
                            <li v-if="activeOrder.order_status===2||activeOrder.order_status===3||activeOrder.order_status===4||activeOrder.order_status===5"
                                class="radio_option_item"
                                @click="handleClickDelOrder">删除
                            </li>
                            <li v-if="activeOrder.order_status===2||activeOrder.order_status===3||activeOrder.order_status===5"
                                class="radio_option_item"
                                @click="handleClickSubmitAgain">重新发起
                            </li>
                            <li v-if="activeOrder.order_status===0||activeOrder.order_status===1"
                                class="radio_option_item" @click="handleClickCopyOrder">复制订单
                            </li>
                            <li v-if="activeOrder.order_status===1&&Number(activeOrder.purchase_price)!==0"
                                class="radio_option_item" @click="handleClickAddPurchase">新增代采
                            </li>
                            <li v-if="activeOrder.order_status===1" class="radio_option_item"
                                @click="handleClickAddMember">添加成员
                            </li>
                            <li v-if="activeOrder.order_status===1" class="radio_option_item"
                                @click="handleClickCloseOrder">关闭订单
                            </li>
                            <li v-if="activeOrder.order_status!==4" class="radio_option_item"
                                @click="handleClickCopyOrderNum">编号复制
                            </li>
                        </ul>
                        <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                    </div>
                </van-overlay>
                <OrderAdd v-if="addOrderDialogVisible"
                          :dialogVisible.sync="addOrderDialogVisible"
                          @refresh-list="onSearch"/>
                <OrderEdit v-if="editOrderDialogVisible"
                           :dialogVisible.sync="editOrderDialogVisible"
                           :order_id="activeOrder.order_id"
                           @refresh-list="onSearch"/>
                <OrderSubmitAgain v-if="submitAgainOrderDialogVisible"
                                  :dialogVisible.sync="submitAgainOrderDialogVisible"
                                  :order_id="activeOrder.order_id"
                                  @refresh-list="onSearch"/>
                <OrderPurchaseAdd v-if="orderPurchaseAddVisible"
                                  :dialogVisible.sync="orderPurchaseAddVisible"
                                  :order_id="activeOrder.order_id"/>
                <OrderAddMember v-if="teamMembersAddVisible"
                                :dialogVisible.sync="teamMembersAddVisible"
                                :order_ids="[activeOrder.order_id]"/>
                <OrderAfterSale v-if="orderAfterSaleDialog"
                                :dialogVisible.sync="orderAfterSaleDialog"
                                :order_id="activeOrder.order_id"
                                @order_edit="handleClickEditOrder"
                                @refresh="onSearch"/>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import OrderPurchaseAdd from './component/order_purchase_add'
import OrderAddMember from "@/views/mobile/Order/component/add_member.vue";
import {cancelApproval, orderClose, orderDel, orderHasAfterSale, orderList} from "@/api";
import {pagination} from "@/mixins";
import {mapState} from "vuex";
import OrderAdd from "@/views/mobile/Order/component/order_add";
import OrderEdit from "@/views/mobile/Order/component/order_edit"
import OrderSubmitAgain from "@/views/mobile/Order/component/order_submit_again";
import OrderAfterSale from "@/views/mobile/Order/component/order_afte_sale";

export default {
    name: "OrderList",
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "Order",
                    title: "首页",
                },
                {
                    icon: "icon-a-dingdan1",
                    activeIcon: "icon-a-dingdan26",
                    routerName: "OrderList",
                    title: "订单",
                },
                {
                    icon: "icon-tuikuan",
                    activeIcon: "icon-tuikuan1",
                    routerName: "PaymentList",
                    title: "回款",
                },
                {
                    icon: "icon-fapiao",
                    activeIcon: "icon-a-fapiao1",
                    routerName: "InvoiceList",
                    title: "开票",
                },
            ],
            tabBarActive: 1,
            searchForm: {
                keyword: '',
            },
            custom_filter: [],
            orderTableList: [],
            systemFilterFields: [
                {
                    field_type: "radio",
                    field_key: 'is_deliver',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '产品租售方式',
                    options: [
                        {
                            label: "包含销售",
                            value: 1,
                        },
                        {
                            label: "包含租借",
                            value: 2,
                        }
                    ],
                    system_type: 'logic',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'is_expire_goods',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '是否有到期设备',
                    options: [
                        {
                            label: "否",
                            value: 0,
                        },
                        {
                            label: "是",
                            value: 1,
                        }
                    ],
                    system_type: 'logic',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'order_status',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '订单状态 ',
                    options: [
                        {
                            label: "审批中",
                            value: 0,
                        },
                        {
                            label: "已通过",
                            value: 1,
                        },
                        {
                            label: "已拒绝",
                            value: 2,
                        },
                        {
                            label: "已撤销",
                            value: 3,
                        },
                        {
                            label: "未发布",
                            value: 4,
                        },
                        {
                            label: "已关闭",
                            value: 5,
                        },
                    ],
                    system_type: 'logic',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'orders.is_deliver',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '是否需要发货',
                    options: [
                        {
                            label: "否",
                            value: 0,
                        },
                        {
                            label: "是",
                            value: 1,
                        }
                    ],
                    system_type: 'system',
                    is_multiple: false,
                },
                {
                    field_type: "radio",
                    field_key: 'orders.is_bad_debt',
                    condition_type: 'options',
                    is_system: 1,
                    field_name: '是否有坏账',
                    options: [
                        {
                            "label": "否",
                            "value": 0,
                        },
                        {
                            "label": "是",
                            "value": 1,
                        }
                    ],
                    system_type: 'system',
                    is_multiple: false,
                },
                {
                    field_type: "money",
                    field_key: 'orders.contract_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '订单总金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.total_repay_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '总回款金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.no_repay_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '待回款金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.repay_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '实际回款金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.invoice_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '总开票金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.no_invoice_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '可开票金额',
                    system_type: 'system',
                },
                {
                    field_type: "money",
                    field_key: 'orders.purchase_cost_price',
                    condition_type: 'number',
                    is_system: '1',
                    field_name: '代采成本',
                    system_type: 'system',
                },
                {
                    field_type: "date",
                    field_key: 'orders.created_at',
                    date_type: 'date',
                    condition_type: 'date_range',
                    is_system: '1',
                    field_name: '创建时间',
                    system_type: 'system',
                },
                {
                    field_type: "radio",
                    field_key: 'orders.deliver_status',
                    is_system: '1',
                    condition_type: 'options',
                    field_name: '发货状态',
                    options: [
                        {
                            "label": "未发货",
                            "value": 1,
                            "default": false,
                            "error": ""
                        },
                        {
                            "label": "全部发货",
                            "value": 2,
                            "default": false,
                            "error": ""
                        },
                        {
                            "label": "部分发货",
                            "value": 3,
                            "default": false,
                            "error": ""
                        },
                    ],
                    system_type: 'system',
                    is_multiple: true,
                },
                {
                    field_type: "radio",
                    field_key: 'orders.is_return_goods',
                    is_system: '1',
                    condition_type: 'options',
                    field_name: '是否有未归还设备',
                    options: [
                        {
                            label: "否",
                            value: 0,
                        },
                        {
                            label: "是",
                            value: 1,
                        }
                    ],
                    system_type: 'system',
                    is_multiple: true,
                }
            ],
            defaultImg: require('@/assets/images/default.jpg'),
            handleRadioPicker: false,
            activeOrder: {},
            orderPurchaseAddVisible: false,
            editOrderDialogVisible: false,
            teamMembersAddVisible: false,
            addOrderDialogVisible: false,
            submitAgainOrderDialogVisible: false,
            orderAfterSaleDialog: false,
        }
    },
    mixins: [pagination],
    components: {
        OrderSubmitAgain,
        OrderAdd,
        OrderEdit,
        OrderAddMember,
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        ListAdvancedFiltering,
        PersonnelCard,
        OrderPurchaseAdd,
        OrderAfterSale
    },
    computed: {
        ...mapState(["searchPopupShow"]),
    },
    created() {
        this.getOrderTableList()
    },
    mounted() {

    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.$refs.pullContainerRef.pullDownLoadingEnd();
                this.getOrderTableList()
            }
        },

        getOrderTableList() {
            this.loading = true;
            orderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.orderTableList = this.orderTableList.concat(data)
                    this.pagination.total = total
                }
                this.loading = false;
            })
        },

        onSearch() {
            this.pagination.pageNum = 1
            this.orderTableList = []
            this.getOrderTableList()
        },

        //滚动加载列表
        scrollLoadList() {
            if (this.orderTableList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getOrderTableList()
            }
        },

        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },

        getFilterData(data) {
            this.custom_filter = data
            this.onSearch()
        },

        // 点击订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: 'OrderDetail',
                query: {
                    order_id: row.order_id,
                    name: row.order_num
                }
            })
        },

        //点击订单更多操作
        handleClickOrderHandle(row) {
            this.activeOrder = row
            this.handleRadioPicker = true
        },

        //复制订单编号
        handleClickCopyOrderNum() {
            const textarea = document.createElement('textarea');
            textarea.value = this.activeOrder.order_num;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$toast.success('复制成功');
        },

        //订单售后
        handleClickAfterSales() {
            this.orderAfterSaleDialog = true
        },

        // 新建订单
        handleClickAddOrder() {
            this.addOrderDialogVisible = true
        },

        //订单编辑
        handleClickEditOrder() {
            this.editOrderDialogVisible = true
        },

        //订单重新提交
        handleClickSubmitAgain() {
            this.submitAgainOrderDialogVisible = true
        },

        //复制订单
        handleClickCopyOrder() {
            this.submitAgainOrderDialogVisible = true
        },

        //新增代采
        handleClickAddPurchase() {
            orderHasAfterSale({
                order_id: this.activeOrder.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$message.error(res.data.tips)
                    } else {
                        this.orderPurchaseAddVisible = true
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        //添加成员
        handleClickAddMember() {
            this.teamMembersAddVisible = true
        },

        //订单删除
        handleClickDelOrder() {
            this.$dialog.confirm({
                title: '您确定要删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonColor: '#E44144',
            }).then(() => {
                orderDel({
                    order_id: this.activeOrder.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('删除成功！')
                        this.onSearch()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //撤销订单
        handleClickRevokeOrder() {
            this.$dialog.confirm({
                title: '确认撤销吗？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990FF',
            }).then(() => {
                cancelApproval({
                    approval_id: this.activeOrder.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功')
                        this.onSearch()
                    }
                })
            }).catch(() => {

            })
        },

        //关闭订单
        handleClickCloseOrder() {
            this.$dialog.confirm({
                title: '您确定要关闭吗？',
                message: '关闭后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990FF',
            }).then(() => {
                orderClose({
                    order_id: id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('关闭成功！')
                        this.getOrderTableList()
                    }
                })
            }).catch(() => {

            })
        },
    },
}
</script>
<style lang="scss" scoped>
.mobile_container {
    overflow-y: hidden;
    padding-top: 10px;

    .order_list {
        width: 100%;
        height: 100%;
        overflow-y: auto;

        .order_item {
            margin-bottom: 4px;
            background: #FFFFFF;
            padding: 10px 16px 2px;

            .order_item_header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                border-bottom: 1px solid #E8E8E8;
                padding-bottom: 8px;

                .order_num_wrap {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 22px;
                    color: #2990FF;
                }

                .order_status_name {
                    color: #666666;
                    margin-left: 4px;

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        margin-right: 4px;
                        background: #666666;
                        vertical-align: middle;
                    }

                    &.order_status_name_0 {
                        &::before {
                            background: #F0AA32;
                        }
                    }

                    &.order_status_name_1 {
                        &::before {
                            background: #52C41B;
                        }
                    }

                    &.order_status_name_2 {
                        &::before {
                            background: #E44144;
                        }
                    }

                    &.order_status_name_3 {
                        &::before {
                            background: #BFBFBF;
                        }
                    }

                    &.order_status_name_5 {
                        &::before {
                            background: #BFBFBF;
                        }
                    }
                }
            }

            .order_item_content {
                padding-top: 10px;

                .flex_wrap {
                    line-height: 22px;
                    margin-bottom: 8px;
                }

                .field_label {
                    color: #999999;
                }

                .field_value {
                    color: #333333;
                }
            }
        }
    }
}

</style>